import { RecordObject } from 'src/models';

export const CONTENT_TYPE: RecordObject<RecordObject<unknown>> = {
  FormData: { 'Content-Type': 'multipart/form-data;' },
};
